import React from 'react';
import { NavLink } from 'react-router-dom';
import './RegulatorikSubNav.css';

const RegulatorikSubNav = () => {
    const subNavItems = [
        { id: 'neuigkeiten', label: 'Neuigkeiten / Updates', path: 'neuigkeiten' },
        { id: 'archiv', label: 'Archiv', path: 'archiv' },
        { id: 'gesetze', label: 'Gesetze / Richtlinien', path: 'gesetze' },
    ];

    return (
        <nav className="regulatorik-subnav">
            <div className="subnav-container">
                {subNavItems.map((item) => (
                    <NavLink
                        key={item.id}
                        to={item.path}
                        className={({ isActive }) =>
                            `subnav-item ${isActive ? 'active' : ''}`
                        }
                    >
                        {item.label}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
};

export default RegulatorikSubNav;